module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-vehicle-costs"
  }, [_c('div', {
    staticClass: "action-bar"
  }, [_vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('CreateNoteModal', {
    attrs: {
      "entity": _vm.note.type,
      "entityId": _vm.$route.params.id
    },
    on: {
      "noteCreated": _vm.addNote
    }
  })], 1)]), _c('div', {
    staticClass: "container"
  }, [_c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "component-type": "entityList"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Vehicle Notes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f9ea51e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleNotes.vue
// module id = 2473
// module chunks = 1